import React from "react";
import round from "lodash/round";

const SingleNutrient = ({ nutrient, value, target }) => {
  const gramsLeft = target ? round(target - value, 0) : null;
  let percentage = target ? round((value * 100) / target, 0) : 0;

  if (percentage > 100) percentage = 100;

  return (
    <div>
      <div className="nutrient-target-row">
        <span className="nutrient-target title">{nutrient}</span>
        <div>
          <span className="nutrient-target value">
            {round(value, 1)} {!!target ? "/" : "g"}
          </span>
          {!!target && (
            <span className="nutrient-target target">
              {" "}
              {round(target, 0)} g
            </span>
          )}
          {!!target && (
            <span
              className={`nutrient-target target${
                gramsLeft < 0 ? " over" : ""
              }`}
            >
              {` (${Math.abs(gramsLeft)}g ${gramsLeft < 0 ? "over" : "left"})`}
            </span>
          )}
        </div>
      </div>
      <div className="nutrient-target-bar">
        <div
          className={`nutrient-target-bar filled ${nutrient}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

const NutritionTarget = ({
  targetData = {},
  dayStats,
  showFiberAlways = false,
}) => {
  const nutrients = (dayStats && dayStats.nutrients) || {};
  const proteinsDays = (dayStats && dayStats.proteinsDays) || 0;
  const carbsDays = (dayStats && dayStats.carbsDays) || 0;
  const fatsDays = (dayStats && dayStats.fatsDays) || 0;
  const fibersDays = (dayStats && dayStats.fibersDays) || 0;
  const { carbs = 0, fats = 0, proteins = 0, fibers = 0 } = nutrients;
  const { targetCarbs, targetFats, targetProteins, targetFibers } = targetData;

  const convertedProteins = proteinsDays
    ? Math.round(proteins / proteinsDays)
    : proteins;
  const convertedCarbs = carbsDays ? Math.round(carbs / carbsDays) : carbs;
  const convertedFats = fatsDays ? Math.round(fats / fatsDays) : fats;
  const convertedFibers = fibersDays ? Math.round(fibers / fibersDays) : fibers;

  return (
    <div className="nutrition-target">
      <SingleNutrient
        nutrient="Protein"
        value={convertedProteins}
        target={targetProteins}
      />
      <SingleNutrient
        nutrient="Carbohydrates"
        value={convertedCarbs}
        target={targetCarbs}
      />
      <SingleNutrient
        nutrient="Fat"
        value={convertedFats}
        target={targetFats}
      />
      {(!!targetFibers || showFiberAlways) && (
        <SingleNutrient
          nutrient="Fiber"
          value={convertedFibers}
          target={targetFibers}
        />
      )}
    </div>
  );
};

export default NutritionTarget;
